import { capitalize } from './capitalize'
import langs from './language.json'

// ------------------------------------------------------
// Standard replacer for sentences with some placeholders
// that need to be replaced by a list of terms
// ------------------------------------------------------
export function replaceList( text, place1, place2, list, lang = "" ) {

  const dict = langs[ lang ]

  if ( list.length === 0 ) {
    return text
  }

  if ( list.length === 1 ) {
    return text.replace( place1, list[ 0 ] )
  }

  const last = list.pop()
  text = text.replace( place1, list.join( dict.comma ) )
  text = text.replace( place2, last )

  return text
}